import React, { Component } from "react";
import { Chart } from "chart.js";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Button,
} from "@mui/material";
const buildData = (cellVoltArr,cellNoArr)=>{
 
  const _data = {
    datasets: [
      {
        backgroundColor: "#0892A5",
        barPercentage: 0.5,
        barThickness: 12,
        borderRadius: 4,
        categoryPercentage: 0.5,
        data: cellVoltArr,
        label: "Cell Voltage",
        maxBarThickness: 10,
      },
    ],
    // labels: ["1 Aug", "2 Aug", "3 Aug", "4 Aug", "5 Aug", "6 Aug", "7 aug"],
    labels: cellNoArr ,
  };
  return _data 
}
  
  const _options = {
    animation: false,
    cornerRadius: 0,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    xAxes: [
      {
        ticks: {
          fontColor: "textSecondary",
        },
        gridLines: {
          display: false,
          drawBorder: false,
        },
      },
    ],
    yAxes: [
      {
        ticks: {
          fontColor: "textSecondary",
          beginAtZero: true,
          min: 0,
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
        },
      },
    ],
    tooltips: {
      backgroundColor: "#C1ECE2",
      bodyFontColor: "textSecondary",
      borderWidth: 1,
      enabled: true,
      footerFontColor: "textSecondary",
      intersect: false,
      mode: "index",
      titleFontColor: "textSecondary",
      callbacks:{
        label: function(tooltipItem, data) {
          return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel + " V";
        },
        title: function(tooltipItem, data) {
            console.log("ToolTip:",tooltipItem)
            return "Cell Num"+ tooltipItem[0].xLabel
        },
      },
    },
  };

class CellVoltChartWrap extends Component {

  constructor(props) {
    super(props);

  }

  componentDidMount() {
    const {cellVoltArr, cellNoArr} = this.props;
    console.log('Data',cellVoltArr,"Options",cellNoArr);
    this.chart = new Chart(this.refs.chart, {
      type: "line",
      data: buildData(cellVoltArr, cellNoArr),
      options: _options,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // if(this.chart) {
    
    const {cellVoltArr, cellNoArr} = this.props;
    this.chart.data.datasets[0].data = cellVoltArr;
    this.chart.data.labels = cellNoArr;
    this.chart.update();
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  render() {
    
    return (
      <Card>
        <CardHeader
          title="Cell Voltage"
        />
        <Divider />
        <CardContent>
          <Box
            sx={{
              height: 400,
              position: "relative",
            }}
          >
            <canvas ref="chart"></canvas>
          </Box>
        </CardContent>
      </Card>
    );
  }
}
export default CellVoltChartWrap;
